import React from 'react'
import {useIntl} from 'react-intl'
import {AzPageHeader} from '../../components/AzPageHeader'
import {ClientsList} from './clients-list/ClientsList'
import {ListViewProvider} from '../user-management/users-list/core/ListViewProvider'
import {QueryRequestProvider} from '../user-management/users-list/core/QueryRequestProvider'
import {QueryResponseProvider} from '../user-management/users-list/core/QueryResponseProvider'

const ClientsPage = () => {
  const intl = useIntl()
  return (
    <>
      <AzPageHeader
        title={intl.formatMessage({id: 'MENU.CLIENTS'})}
        subtitle={intl.formatMessage({id: 'CLIENTS.PAGE_DESCRIPTION'})}
      />
      <ListViewProvider>
        <QueryRequestProvider>
          <QueryResponseProvider>
            <ClientsList />
          </QueryResponseProvider>
        </QueryRequestProvider>
      </ListViewProvider>
    </>
  )
}

export default ClientsPage
